import { logger } from './logger';

// Environment configuration utility
export const config = {
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000',
    version: process.env.REACT_APP_API_VERSION || 'local',
  },
  environment: process.env.REACT_APP_ENV || 'development',
};

logger.debug('process.env.REACT_APP_API_BASE_URL', process.env.REACT_APP_API_BASE_URL);

// Debug function to check if environment variables are loaded
export const logEnvironmentVariables = () => {
  logger.info('Environment Variables:', {
    REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
    REACT_APP_API_VERSION: process.env.REACT_APP_API_VERSION,
    REACT_APP_ENV: process.env.REACT_APP_ENV,
    NODE_ENV: process.env.NODE_ENV,
  });
};

export default config;